import React, { useState, useEffect, useMemo } from 'react';
import { supabase } from './supabase';
import AuthInterface from './components/AuthInterface';
import PaneManager from './components/PaneManager';
import BotListPane from './components/BotListPane';
import ChatPane from './components/ChatPane';
import './App.css';
import './AIMChat.css';

function App() {
  const [user, setUser] = useState(null);
  const [selectedNeobot, setSelectedNeobot] = useState(null);

  useEffect(() => {
    // Check for existing session
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user || null);
    };

    getSession();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        setUser(session?.user || null);
        if (!session?.user) {
          setSelectedNeobot(null);
        }
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  // Create panes using useMemo to prevent unnecessary recreations
  const panes = useMemo(() => {
    if (!user) return [];

    const basePanes = [
      {
        id: 'botList',
        component: (
          <BotListPane 
            user={user} 
            onBotSelect={setSelectedNeobot}
            selectedNeobot={selectedNeobot}
          />
        ),
        initialPosition: { x: 20, y: 20 },
        initialSize: { width: 350, height: 600 },
        minSize: { width: 300, height: 400 }
      }
    ];

    // Add chat pane if a bot is selected
    if (selectedNeobot) {
      basePanes.push({
        id: 'chat',
        component: (
          <ChatPane 
            neobot={selectedNeobot} 
            user={user}
          />
        ),
        initialPosition: { x: 400, y: 20 },
        initialSize: { width: 500, height: 700 },
        minSize: { width: 400, height: 500 }
      });
    }

    return basePanes;
  }, [user, selectedNeobot]);

  if (!user) {
    return <AuthInterface />;
  }

  return (
    <div className="App">
      <PaneManager panes={panes}>
        {/* Additional UI elements can go here */}
      </PaneManager>
    </div>
  );
}

export default App;
